import { useEffect, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function AISummaryPopup({ onClose, patientId, customPrompt, promptName, examId, scope, open }) {
  const { t } = useTranslation();
  const hasOpened = useRef(false);

  const openWindow = useCallback(() => {
    if (!patientId) return;

    const width = 550;
    const height = 700;
    const left = Math.floor((window.screen.availWidth - width) / 2);
    const top = Math.floor((window.screen.availHeight - height) / 2);

    const params = new URLSearchParams();
    params.set('patientId', patientId);

    if (promptName) {
      params.set('promptName', promptName);
    }

    if (examId && scope === 'current_exam') {
      params.set('examId', examId);
    }

    if (customPrompt) {
      const storageKey = `ai_summary_prompt_${Date.now()}`;
      localStorage.setItem(storageKey, customPrompt);
      params.set('storageKey', storageKey);
    }

    const isDark = document.documentElement.getAttribute('data-mui-color-scheme') === 'dark'
      || document.body.classList.contains('dark-mode')
      || window.matchMedia?.('(prefers-color-scheme: dark)').matches;
    if (isDark) params.set('dark', '1');

    window.open(
      `/ai-summary-popup?${params.toString()}`,
      `ai_summary_${patientId}`,
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
    );

    if (onClose) onClose();
  }, [patientId, customPrompt, promptName, examId, scope, onClose]);

  useEffect(() => {
    if (open && !hasOpened.current) {
      hasOpened.current = true;
      openWindow();
    }
    if (!open) {
      hasOpened.current = false;
    }
  }, [open, openWindow]);

  return null;
}
